import { useState } from 'react'

import { SelectOption } from 'components/Select'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { GET_WORKSPACES_FOR_SELECT } from './api/query'
import { Data, WorkspaceSliceDTO } from './api/types'
import { mapFromDTO } from './mapper'
import { UseGetWorkspaceOptions, WorkspaceSlice } from './types'

export const useGetWorkspaceOptions = (): UseGetWorkspaceOptions => {
  const [workspaceOptions, setWorkspaceOptions] = useState<SelectOption<WorkspaceSlice>[]>([])

  const { isLoading } = useQuery<never, Data>({
    onCompleted: async data => {
      const {
        workspaces: { nodes },
      } = data

      if (nodes) {
        setWorkspaceOptions(
          nodes.map(
            (workspace: WorkspaceSliceDTO): SelectOption<WorkspaceSlice> => mapFromDTO(workspace),
          ),
        )
      }
    },
    query: GET_WORKSPACES_FOR_SELECT,
  })

  return {
    loading: isLoading,
    workspaceOptions,
  }
}
